import * as ImageActions from '@Actions/images.actions';
import { put, retry, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { fetchImagePath } from '@Services/liftStations';
import { PayloadAction } from '@reduxjs/toolkit';
import { ImagePathResponse } from '@Types/images.types';

function* getImagePathSaga(action: PayloadAction<string>) {
	try {
		const response: AxiosResponse<ImagePathResponse> = yield retry(
			1,
			1500,
			fetchImagePath,
			action.payload,
		);
		if (response.data.location) {
			yield put(
				ImageActions.getImagePathResolved({
					key: action.payload,
					path: response.data.location,
					resolved: true,
				}),
			);
		} else {
			yield put(
				ImageActions.getImagePathResolved({
					key: action.payload,
					path: '',
					resolved: false,
				}),
			);
		}
	} catch {
		yield put(
			ImageActions.getImagePathResolved({
				key: action.payload,
				path: '',
				resolved: false,
			}),
		);
	}
}

function* watchGetImagePathes() {
	yield takeEvery(ImageActions.getImagePath, getImagePathSaga);
}

export default [watchGetImagePathes()];
